export default __webpack_public_path__ + "static/media/rockvilleLogo.5df6f7d3.svg";